import { IconProps } from "./IconProps";

const CloseInCircleIcon = ({ size = 24, color, testID }: IconProps) => (
  <svg
    width={size}
    height={size}
    color={color}
    data-testid={testID}
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99968 0.833328C7.54998 0.833328 5.24701 1.78683 3.51486 3.51816C-0.0609251 7.09222 -0.0609251 12.9077 3.51475 16.4818C5.2469 18.2132 7.54998 19.1667 9.99968 19.1667C12.4493 19.1667 14.7524 18.2132 16.4845 16.4818C20.0603 12.9077 20.0603 7.09222 16.4845 3.51816C14.7524 1.78683 12.4493 0.833328 9.99968 0.833328ZM14.1264 14.1247C13.9635 14.2874 13.7502 14.3688 13.5368 14.3688C13.3235 14.3688 13.1101 14.2874 12.9474 14.1247L9.99968 11.1785L7.05202 14.1248C6.88917 14.2875 6.67585 14.3689 6.46247 14.3689C6.24915 14.3689 6.03571 14.2875 5.87302 14.1248C5.54737 13.7994 5.54737 13.2717 5.87302 12.9463L8.82063 9.99999L5.87297 7.05372C5.54732 6.72833 5.54732 6.20066 5.87297 5.87522C6.19851 5.54983 6.72642 5.54983 7.05202 5.87522L9.99968 8.82149L12.9472 5.87522C13.2728 5.54983 13.8007 5.54983 14.1263 5.87522C14.4519 6.20061 14.4519 6.72827 14.1263 7.05372L11.1787 9.99999L14.1264 12.9462C14.452 13.2717 14.452 13.7993 14.1264 14.1247Z"
      fill="currentColor"
    />
  </svg>
);

export { CloseInCircleIcon };
